export default __webpack_public_path__ + "static/media/step_001.8f1afd1e.jpeg";